/**
 * Device template configuration
 * Matches: Device.Liquidation
 */
import type { TemplateConfig, TemplateField } from '../types'
import { createExpandedRowRender } from '../../expanded-row'
import {
    defaultQuotaCalculator,
    defaultIsExpandable,
    DEFAULT_FIELDS,
} from '../shared'

// ============================================================================
// Fields
// ============================================================================

export const DEVICE_FIELDS: TemplateField[] = DEFAULT_FIELDS

// ============================================================================
// Template Config
// ============================================================================

export const deviceLiquidationTemplate: TemplateConfig = {
    id: 'device-liquidation',
    patterns: ['device.liquidation'],
    priority: 10,
    fields: DEVICE_FIELDS,
    expandedRow: {
        createRenderer: createExpandedRowRender,
        isExpandable: defaultIsExpandable,
    },
    calculateQuota: defaultQuotaCalculator,
}

// Export all device templates
export const deviceTemplates = [deviceLiquidationTemplate]
